import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment/moment';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { addFeedback } from '../../API/RDPMS_API';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const AlertFeedbackModal = ({ status, archievesId, masterId, stationId, notificationId, alertMaintenance, onHide }) => {
    const { t } = useTranslation();
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    const schema = yup.object().shape({
        descriptions: yup.string().required(t('Please enter remarks')),
        causeCode: yup.string(),
        rectification_date_time: yup.string().required(t('Please select rectification date time')),
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = async (formData) => {
        let request = {
            maintainerDesignation: auth?.user?.role || '',
            maintainerMobile: auth?.user?.contact || '',
            maintainerName: auth?.user?.name || '',
            name: '',
            archievesId,
            masterId,
            stationId,
            notificationId,
            alert:
                status === 'T'
                    ? 'Valid'
                    : status === 'F'
                    ? 'Invalid'
                    : status === 'PT'
                    ? 'PT'
                    : status === 'M'
                    ? 'Maintenance'
                    : '',
            descriptions: formData.descriptions,
            file: formData.file,
            rectificationDateTime: formData?.rectification_date_time,
            causeCode: formData?.causeCode || '',
        };
        // console.log(request, 'request.....');

        let response = await addFeedback(request);

        if (response) {
            toast.success('Added feedback sucessfully', {
                position: toast.POSITION.TOP_RIGHT,
            });
            onHide();
        } else {
            toast.error('Please try again', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    const getAlertLabel = (status) => {
        switch (status) {
            case 'T':
                return t('True');
            case 'F':
                return t('False');
            case 'M':
                return t('Maintenance');
            case 'PT':
                return t('Partially True');
            default:
                return '-';
        }
    };

    return (
        <>
            {/* <ToastContainer /> */}

            <div style={{ marginBottom: '14px' }}>
                <strong>{t('Alert is')}:</strong>
                <span style={{ marginLeft: '10px' }}>{getAlertLabel(status)}</span>
            </div>

            <Form onSubmit={handleSubmit(onSubmit)}>
                {status === 'PT' && (
                    <Form.Group className="mb-3">
                        <Form.Label>{t('Cause Code')}</Form.Label>
                        <Form.Control type="text" {...register('causeCode')} isInvalid={!!errors.causeCode} />
                        {errors.causeCode && (
                            <Form.Control.Feedback type="invalid">{errors.causeCode.message}</Form.Control.Feedback>
                        )}
                    </Form.Group>
                )}

                <Form.Group className="mb-3">
                    <Form.Label>{t('Attach photo or pdf file')}</Form.Label>
                    <Form.Control type="file" {...register('file')} isInvalid={!!errors.file} multiple />
                    {errors.file && <Form.Control.Feedback type="invalid">{errors.file.message}</Form.Control.Feedback>}
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Rectification Date & Time</Form.Label>
                    <Form.Control
                        type="datetime-local"
                        min={new Date().toISOString().slice(0, 16)}
                        {...register('rectification_date_time')}
                        isInvalid={!!errors.rectification_date_time}
                    />
                    {errors.rectification_date_time && (
                        <Form.Control.Feedback type="invalid">
                            {errors.rectification_date_time.message}
                        </Form.Control.Feedback>
                    )}
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>{t('Remarks')}</Form.Label>
                    <Form.Control
                        as="textarea"
                        defaultValue={alertMaintenance === false ? 'Under Maintenance' : ''}
                        rows={3}
                        {...register('descriptions')}
                        isInvalid={!!errors.descriptions}
                    />
                    {errors.descriptions && (
                        <Form.Control.Feedback type="invalid">{errors.descriptions.message}</Form.Control.Feedback>
                    )}
                </Form.Group>
                <div className="text-end">
                    <Button type="submit" className="btn btn-success mt-2">
                        <i className="mdi mdi-content-save"></i> {t('Send Feedback')}
                    </Button>
                </div>
            </Form>
        </>
    );
};

export default AlertFeedbackModal;
